import styled from 'styled-components';

import { paragraphs } from '@proprioo/salatim';

export const RemainingTime = styled.div`
  ${paragraphs.body2};
  font-weight: bold;
`;
